import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal  } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import "./Home.css"
import Account from './Account';
import Instance from './Instance';
import Token from './Token';

 export const getIdTokenHintFromHash = () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1)); // Remove the leading #
    console.log('params ---', hash);
 return params.get('id_token');
 };

function Home (){    
    const [idToken, setIdToken] = useState(null);    
    const { instance, accounts, inProgress } = useMsal();            

    const [searchParams, setSearchParams] = useSearchParams();
    let id_token_hint = searchParams.get("id_token_hint")
    // let id_token_hint = getIdTokenHintFromHash();
    console.log('id_token_hint ->', id_token_hint);


   // const [editPermissionText, setEditPermissionText] = useState(null);

    const Login = async () => {        
        try {
            // let {idToken} = await instance.loginPopup();
            let {idToken} = await instance.loginRedirect();

        } catch (error) {
            console.error(error);
        }        
    }

    const Logout = async () => {
        try {
            // await instance.logoutPopup();
            await instance.logoutRedirect();
                        
        } catch (error) {
            console.error(error);
        }
    }

    const LoginMagic = async (id_token_hint) => {
        
        try {
            // let c = msalConfig;
            // msalConfig.auth.authority = 'https://klaitonciam.b2clogin.com/klaitonciam.onmicrosoft.com/B2C_1A_SIGNIN_WITH_MAGIC_LINK';
            // console.log('c', c)
            // const pca = new PublicClientApplication(c);
            console.log('here')
            // msalConfig.auth.authority = 'https://klaitonciam.b2clogin.com/klaitonciam.onmicrosoft.com/B2C_1A_SIGNIN_WITH_MAGIC_LINK';
            // await instance.loginRedirect(loginRedirectRequest);

            instance.config.auth.authority = 'https://klaitonciam.b2clogin.com/klaitonciam.onmicrosoft.com/B2C_1A_SIGNIN_WITH_MAGIC_LINK'

            console.log(instance);

            if (id_token_hint) {
                const request = {
                  scopes: ["openid", "profile"], // Specify your scopes
                  loginHint: id_token_hint,
                  extraQueryParameters: {
                    id_token_hint: id_token_hint
                    
                  },
                };
          
                instance.ssoSilent(request).then(response => {
                  console.log("User logged in silently", response);
                }).catch(error => {
                  console.error("Silent SSO failed", error);
                  // Fallback to interactive login if silent SSO fails
                  instance.loginRedirect(request);
                });
              }
        } catch (error) {
            console.error(error);
        }
    }
    
  
    useEffect(() => {       
                
        console.log('inProgress', inProgress, id_token_hint);
        if(inProgress === 'startup' && id_token_hint) {
            LoginMagic(id_token_hint);
        }
                
        
        
    }, []); 



    return (
        <div className="home"> 
                <p className="text-left fw-bold pt-3"> 
                    Klaiton CIAM Test Client
                </p>
                Use this site to test your external Klaiton credentials
                <p></p>
            <AuthenticatedTemplate>                
                <div className="alert alert-success" role="alert">
                   Sie sind angemeldet! 😊 <button type="button" className="btn btn-dark btn-sm float-end" onClick={() => Logout()}>Abmelden</button>                   
                </div>                
                <Account account={accounts[0]}></Account>
                <Instance instance={instance}></Instance>
                <Token instance={instance} account={accounts[0]}></Token>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <div className="alert alert-warning" role="alert">
                    Sie sind nicht angemeldet 🥺
                    <button type="button" className="btn btn-dark btn-sm float-end" onClick={() => Login()}>Login</button>
                </div>
            </UnauthenticatedTemplate>
        </div>
    )
}

export default Home;